import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from "react";
import Modal from "./Modal";
import DialogAction from "./DialogAction";
function ServiceFilterForm(t0) {
  const $ = _c(30);
  const {
    services,
    appliedServices,
    onClose,
    onSave,
    renderService
  } = t0;
  let t1;
  if ($[0] !== appliedServices) {
    t1 = () => appliedServices.map(_temp);
    $[0] = appliedServices;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [draft, setDraft] = useState(t1);
  const submitted = useRef(false);
  let t2;
  if ($[2] !== draft || $[3] !== onClose || $[4] !== onSave) {
    t2 = event => {
      event.preventDefault();
      if (submitted.current) {
        return;
      }
      submitted.current = true;
      onSave(draft);
      onClose();
    };
    $[2] = draft;
    $[3] = onClose;
    $[4] = onSave;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== draft || $[7] !== renderService || $[8] !== services) {
    let t4;
    if ($[10] !== draft || $[11] !== renderService) {
      t4 = service => <label key={service.route_id}><div className="flex cursor-pointer items-center gap-x-4 px-[20px] py-3 outline-none hover:bg-zinc-400/10 focus-visible:ring focus-visible:ring-inset active:bg-zinc-400/10"><input type="checkbox" value={service.route_id} checked={draft.some(item => item.route_id === service.route_id)} onChange={event_0 => {
            const checked = event_0.target.checked;
            setDraft(previous => {
              const remaining = previous.filter(item_0 => item_0.route_id !== service.route_id);
              return checked ? [...remaining, {
                route_id: service.route_id
              }] : remaining;
            });
          }} className="h-5 w-5 appearance-none rounded-lg bg-zinc-400/20 outline-none ring-1 ring-inset ring-white/20 transition-all duration-150 checked:bg-blue-500 focus:outline-none focus-visible:ring" />{renderService(service)}</div></label>;
      $[10] = draft;
      $[11] = renderService;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    t3 = services.map(t4);
    $[6] = draft;
    $[7] = renderService;
    $[8] = services;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[13] !== t3) {
    t4 = <div className="relative flex max-h-[calc(var(--vvh)-13rem)] flex-col overflow-y-auto">{t3}</div>;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DialogAction type="submit">Save</DialogAction>;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== onClose) {
    t6 = <DialogAction onClick={onClose}>Cancel</DialogAction>;
    $[16] = onClose;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex-1" />;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setDraft([]);
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const t9 = draft.length ? "" : "invisible";
  const t10 = draft.length === 0;
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = <DialogAction onClick={t8} destructive={true} className={t9} disabled={t10}>Clear All</DialogAction>;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t6) {
    t12 = <div className="flex flex-row-reverse gap-2 p-3 font-semibold text-blue-500 dark:text-white">{t5}{t6}{t7}{t11}</div>;
    $[23] = t11;
    $[24] = t6;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t2 || $[28] !== t4) {
    t13 = <form onSubmit={t2}>{t4}{t12}</form>;
    $[26] = t12;
    $[27] = t2;
    $[28] = t4;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}

// The draft has the lifetime of one open dialog. Dismissal and page unmount
// discard it; every reopen starts from the latest applied preferences.
function _temp(t0) {
  const {
    route_id
  } = t0;
  return {
    route_id
  };
}
export default function ServiceFilterModal(t0) {
  const $ = _c(13);
  const {
    isOpen,
    onClose,
    services,
    appliedServices: t1,
    onSave,
    renderService
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const appliedServices = t2;
  let t3;
  if ($[2] !== appliedServices || $[3] !== isOpen || $[4] !== onClose || $[5] !== onSave || $[6] !== renderService || $[7] !== services) {
    t3 = isOpen && <ServiceFilterForm services={services} appliedServices={appliedServices} onClose={onClose} onSave={onSave} renderService={renderService} />;
    $[2] = appliedServices;
    $[3] = isOpen;
    $[4] = onClose;
    $[5] = onSave;
    $[6] = renderService;
    $[7] = services;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isOpen || $[10] !== onClose || $[11] !== t3) {
    t4 = <Modal isOpen={isOpen} onClose={onClose} title="Filter by Service">{t3}</Modal>;
    $[9] = isOpen;
    $[10] = onClose;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}